import { KnownProfileDataResponses } from '@/components/User/types/profile';
import { FETCH_PROFILE_REQUEST, RECEIVE_PROFILE, RECEIVE_PROFILE_KO } from '../constants/index'

export function receiveProfile(res: KnownProfileDataResponses) {
  return {
    type: RECEIVE_PROFILE,
    payload: res,
  };
}

export function receiveProfileError() {
  return {
    type: RECEIVE_PROFILE_KO,
  };
}

export function fetchProfileRequest() {
  return {
    type: FETCH_PROFILE_REQUEST,
  };
}